import { useApi } from '@/api';
import { Flex, Card, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';
import { ChartTimeFilter } from '@/components';
import { useParams } from 'react-router';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

type MarketHistoricData = {
  results: SimpleChartData[];
  symbol: string;
  name: string;
};

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const { marketAddress } = useParams() as {
    marketAddress: string;
  };
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('borrow_repay');
  const displayOptions = useMemo(
    () => [
      { key: 'borrow_repay', value: 'Borrow/Repay' },
      { key: 'supply_withdraw', value: 'Supply/Withdraw' },
      { key: 'net_flow', value: 'Net Flow' },
      { key: 'active_wallets', value: 'Active Wallets' }
    ],
    []
  );

  const [data, error] = useApi<MarketHistoricData>({
    url: `/markets/${marketAddress}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        flexDirection={['column', 'row']}
        alignItems={['center', 'flex-start']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
          alignContent="center"
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      <HistoricGraphs
        data={data.results}
        type={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
        currencySymbol={data.symbol}
      />
    </Card>
  );
}
